import './single-product.scss';

(function() {
  const tabLinks = document.querySelectorAll('.tabs__link, .outside-tab-link');
  const tabBodies = document.querySelectorAll('.tabs__body');
  const bookNowLinks = document.querySelectorAll('.book-now-button');
  const dateSelect = document.getElementById('pa_datum');
  const tourVerlaufParagraphs = document.querySelectorAll('#tab-3 > p strong');
  const days = [];

  [].forEach.call(tourVerlaufParagraphs, tourVerlaufParagraph => {
    let html = tourVerlaufParagraph.innerHTML;
    const regex = /Tag.([^:]+):/;

    const match = html.match(regex);

    if (match) {
      html = html.replace(regex, '');
      tourVerlaufParagraph.innerHTML = html;

      const newStrong = document.createElement('span');
      newStrong.innerHTML = match[0];

      const dateSpan = document.createElement('span');
      days.push(dateSpan);

      tourVerlaufParagraph.prepend(newStrong, dateSpan);
    }
  });

  [].forEach.call(tabLinks, currentLink => {
    currentLink.addEventListener('click', event => {
      if (! currentLink.classList.contains('outside-tab-link')) {
        event.preventDefault();
      }

      const bodyId = currentLink.getAttribute('href');
      const currentBody = document.querySelector(bodyId);

      [].forEach.call(tabLinks, link => {
        if (link === currentLink) {
          link.classList.add('active');
        }
        else {
          link.classList.remove('active');
        }

        if (currentLink.classList.contains('outside-tab-link')) {
          const outsideBodyId = currentLink.getAttribute('href');
          if (link.getAttribute('href') === outsideBodyId) {
            link.classList.add('active');
          }
        }

        [].forEach.call(tabBodies, body => {
          if (body === currentBody) {
            body.classList.add('active');
          }
          else {
            body.classList.remove('active');
          }
        });
      });
    })
  });

  [].forEach.call(bookNowLinks, button => {
    button.addEventListener('click', event => {
      const date = button.dataset.date;
      dateSelect.value = date;

      if ('createEvent' in document) {
        const evt = document.createEvent('HTMLEvents');
        evt.initEvent('change', false, true);
        dateSelect.dispatchEvent(evt);
    }
    else {
      dateSelect.fireEvent('onchange');
    }
    });
  });

  dateSelect.addEventListener('change', () => {
    const date = dateSelect.value;

    function parseDate(input, format) {
      format = format || 'yyyy-mm-dd'; // default format
      var parts = input.match(/(\d+)/g),
          i = 0, fmt = {};
      // extract date-part indexes from the format
      format.replace(/(yyyy|dd|mm)/g, function(part) { fmt[part] = i++; });

      return new Date(parts[fmt['yyyy']], parts[fmt['mm']]-1, parts[fmt['dd']]);
    }

    const viewDate = parseDate(date, 'dd-mm-yyyy');
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    days.forEach((day, id) => {
      days[id].innerHTML = ' ' + viewDate.toLocaleDateString('de-DE', options) + '<br>';
      viewDate.setDate(viewDate.getDate() + 1);
    });

  });
})();